// removed by extract-text-webpack-plugin
module.exports = {"title":"about__title--2ShUY thinBigText","subtitle":"about__subtitle--2yeqU boldBigText","subtitleEmpty":"about__subtitleEmpty--ZHyVY about__subtitle--2yeqU boldBigText","text":"about__text--3rd9R regularText","textSection":"about__textSection--1iaJ2","textBlockWrapper":"about__textBlockWrapper--3-yiD","textBlockNoTitle":"about__textBlockNoTitle--ybPlr","noMargin":"about__noMargin--3yncT","textBlocks":"about__textBlocks--IJJbG","textBlock":"about__textBlock--2Am58","titleWrapperDesktop":"about__titleWrapperDesktop--3OQVm","titleWrapperMobile":"about__titleWrapperMobile--1Hn30"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/About/about.css
// module id = yGnx
// module chunks = 0